// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".purchaseOpens[data-v-319b7793]{font-size:27px}", ""]);
// Exports
module.exports = exports;
